/* unplugin-vue-components disabled */import { render } from "./WorkspaceShell.vue?vue&type=template&id=19c80884"
import script from "./WorkspaceShell.vue?vue&type=script&lang=js"
export * from "./WorkspaceShell.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__